import { render, staticRenderFns } from "./AppBlockScreen.vue?vue&type=template&id=46e952ba&scoped=true"
import script from "./AppBlockScreen.vue?vue&type=script&lang=js"
export * from "./AppBlockScreen.vue?vue&type=script&lang=js"
import style0 from "./AppBlockScreen.vue?vue&type=style&index=0&id=46e952ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e952ba",
  null
  
)

export default component.exports